import { useEffect, useCallback, useState } from 'react'
import useLocalStorage from '../navigator/useLocalStorage'

/**
 * Hook personnalisé pour détecter les changements du ghostMode
 * @returns Objet contenant ghostMode, hasChanged, setGhostMode et toggleGhostMode
 */
export function useGhostModeChange() {
  const [ghostMode, setGhostMode] = useLocalStorage("ghost-mode", false)
  const [hasChanged, setHasChanged] = useState(false)

  // Fonction pour basculer le ghostMode
  const toggleGhostMode = useCallback(() => {
    setGhostMode((prev: boolean) => !prev)
    // Déclencher l'événement pour notifier les autres composants
    window.dispatchEvent(new CustomEvent('refreshGhostModeEvent'))
  }, [setGhostMode])

  // Écouter les changements dans localStorage et les événements personnalisés
  useEffect(() => {
    const checkLocalStorage = () => {
      setHasChanged((prev: boolean) => !prev)
    }

    // Vérifier immédiatement au montage
    checkLocalStorage()

    window.addEventListener('storage', checkLocalStorage)
    window.addEventListener('refreshGhostModeEvent', checkLocalStorage)

    return () => {
      window.removeEventListener('storage', checkLocalStorage)
      window.removeEventListener('refreshGhostModeEvent', checkLocalStorage)
    }
  }, [])

  return {
    ghostMode,
    hasChanged,
    setGhostMode,
    toggleGhostMode,
  }
}

// Fonction utilitaire pour déclencher le refresh depuis n'importe où
export function triggerGhostModeChange() {
  window.dispatchEvent(new CustomEvent('refreshGhostModeEvent'))
}
